<template>

  <div class="p-list-representation-record-modal-content w-100 row">
    <form id="signup-form" class="row w-100" v-on:submit.prevent="submit">

      <div  :class="{ 'p-list-representation-error': $v.formData.title.$error }"  class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
        <label   class=" p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
          عنوان
        </label>
        <input  v-model="formData.title" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
      </div>



      <!-- <div :class="{ 'p-teams-multiselect-error ': $v.formData.cup_id.$error }" class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
        <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
          جام ها
        </label>
        <multiselect
         v-model="valueCup"
         :options="allCups"
         placeholder=''
         label="title"
         track-by="title"
         :show-labels="false"
         :allow-empty="false"
         class="col-lg-8"
         >
         </multiselect>
      </div> -->

      <div :class="{ 'p-teams-multiselect-error ': $v.formData.type.$error }" class="d-flex align-items-center mb-4  p-edit-representation-form-item" >
        <label  class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
          نوع
        </label>
        <multiselect
         v-model="valueTypeTab"
         :options="allTypes"
         placeholder=''
         label="title"
         track-by="title"
         :show-labels="false"
         :allow-empty="false"
         class="col-lg-8"
         >
         </multiselect>
      </div>



    <div class="row w-100">
        <div :class="{ 'p-error-pic': $v.formData.url.$error }"  class="d-flex align-items-start  mb-4 p-edit-representation-form-item" >
          <label   class=" p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
            عکس
          </label>
          <!-- <input v-model="formData.title" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2"> -->
          <selectedPic text="" :form-data="formData" @updateImg="updateImg"></selectedPic>
        </div>
    </div>



    <div class="w-100 row justify-content-center">
      <button type="submit" class="btn btn-primary btn-blue col-lg-2">ثبت</button>
    </div>

  </form>
</div>

</template>

<script>
import { required, minLength,between,numeric } from 'vuelidate/lib/validators'
import startEndSelectTime from './startEndSelectTime';
import selectedPic from './selectedPic';


const checkTypeValueAndLenValue = (value,countCheckValue) => {
  const checkTypeValue = /^\d+$/.test(value);

  if (checkTypeValue) {
    if (value.length == countCheckValue) {
      return true;
    }
    else {
      return false;
    }
  }
  else {
    return false;
  }
}




export default {
  name: 'formData',
  components: {
    startEndSelectTime,
    selectedPic,
  },
  props: {
    formDataOriginal  : {type:Object,default:{}},
    allCups           : {type:[Object,Array],default:[]},
    allTypes          : {type:[Object,Array],default:[]},
    selectedType      : {type:[Object,Array],default:[]},
    selectedCup       : {type:[Object,Array],default:[]},

  },
  data() {
    return {
      formData : {

      },
      valueCup     : '',
      valueTypeTab : '',

    }
  },

  validations: {
    formData : {
        title: {
          required,
        },
        url: {
          required,
        },
        // cup_id: {
        //   required,
        // },
        type: {
          required,
        },


    }

  },


  computed: {

  },

  created() {
    this.formData = this.formDataOriginal;
  },

  mounted () {
    if (typeof(this.selectedType.id) != 'undefined') {
      this.valueTypeTab = this.selectedType;
    }

  },

  watch: {
    selectedType(data){
      this.valueTypeTab = data;
    },

    selectedCup(data){
      this.valueCup = data;
    },

    valueCup(data){
      this.formData.cup_id = data.id;
    },

    valueTypeTab(data){
      this.formData.type = data.value;
    },


  },

  methods: {
    submit() {
      this.$v.$touch()

      console.log(this.formData);
      if (this.$v.$invalid) {
        this.$message.error('لطفا اطلاعات خود را بررسی کنید')
      }
      else {
        this.$emit('submitData',this.formData)
      }

    },

    updateImg(blobFile){
      this.formData.url = blobFile;
    },


  },

}
</script>
